<script lang="ts">
	import type { SvelteAsr } from 'types/common'

	import { onMount } from 'svelte'
	import Button from '@isoftdata/svelte-button'
	import Icon from '@isoftdata/svelte-icon'
	import { populateSessionFromCookie } from 'utility/oauth-helper'

	interface Props {
		asr: SvelteAsr
		error: string | undefined
	}

	let { asr, error }: Props = $props()

	let isLoading = $state(true)
	let errorMessage: string | undefined = $state()

	onMount(async () => {
		if (error) {
			errorMessage = error
			isLoading = false
			return
		}

		try {
			await populateSessionFromCookie()
			// Defer navigation so abstract-state-router finishes activating this
			// state before we ask it to destroy it.
			setTimeout(() => asr.go('app'), 0)
		} catch (err) {
			isLoading = false
			errorMessage = (err as Error)?.message ?? 'OAuth login failed.'
		}
	})
</script>

{#if isLoading}
	<div class="d-flex justify-content-center align-items-center vh-100">
		<div class="text-center">
			<Icon
				isLoading
				class="mb-3"
			/>
			<p class="text-body-secondary">Completing OAuth login...</p>
		</div>
	</div>
{:else if errorMessage}
	<div class="d-flex justify-content-center align-items-center vh-100">
		<div class="text-center">
			<div
				class="alert alert-danger"
				role="alert"
			>
				<h4 class="alert-heading h6">Login failed:</h4>
				{errorMessage}
			</div>
			<Button
				color="link"
				class="p-0"
				onclick={() => asr.go('login')}>Return to login</Button
			>
		</div>
	</div>
{/if}
